import { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import useOutsideAlerter from '../../hooks/useOutsideAlerter'
import { clearItems, getItemsByIdeaId, getItemsByIds, setPreloadedItems } from '../../redux/communityReducers/ItemSlice'
import * as styles from './details.module.css'
import Product from './Product/Product'
import { SaveAllProductsBtn } from './SaveAllProductsBtn'

export const Products = ({ data, preloadedItems, ...props }) => {
  const dispatch = useDispatch()
  const { items, similar, loading: itemLoading } = useSelector(state => state.item)
  const { isAuthenticated } = useSelector(state => state.auth)
  const { savedProductIds } = useSelector(state => state.saveProduct)

  const { productId } = useSelector(state => state.priceTag)
  let allIds = []

  console.log('preloadedItems', preloadedItems)

  // Check if we have preloaded items to use
  const hasPreloadedItems = preloadedItems && preloadedItems.items && preloadedItems.items.length > 0

  useEffect(() => {
    // Clear items when data changes (new design loaded)
    if (!data) {
      dispatch(clearItems())
      return
    }

    // If we have preloaded items and Redux items are empty, use preloaded items
    if (hasPreloadedItems && items.length === 0) {
      // Check if preloaded items match current data structure
      const isMatchingData = (data?.itemIds && preloadedItems.type === 'itemIds') || (data?.idea?.objectId && preloadedItems.type === 'ideaId')

      if (isMatchingData) {
        // Set preloaded items directly to Redux state
        dispatch(setPreloadedItems(preloadedItems.items))
        return
      }
    }

    // Skip API calls if we already have items in Redux state
    if (items.length > 0) {
      return
    }

    // Fallback to original client-side loading
    if (data?.itemIds) {
      dispatch(getItemsByIds(data?.itemIds))
      return
    }

    if (data?.idea?.objectId) {
      dispatch(getItemsByIdeaId(data.idea.objectId))
    }
  }, [dispatch, data, hasPreloadedItems, preloadedItems, items.length])

  const wrapperRef = useRef(null)

  const closeProductBox = target => {
    if (!target) return

    target.classList.remove(styles.show)
    if (window.innerWidth < 600) document.body.style = 'overflow-y: scroll'
  }

  const clickProducts = e => {
    if (window.innerWidth > 600) return
    if (e.target.classList.contains(styles.show)) {
      closeProductBox(e.target)
      return
    }
  }

  useOutsideAlerter(wrapperRef, closeProductBox)

  if (productId) {
    similar.map((d, i) => {
      allIds.push(d.objectId)
    })
  } else {
    items.map((d, i) => {
      if (d?.objectId) allIds.push(d.objectId)
    })
  }

  return (
    <div ref={wrapperRef} id={'products'} className={styles.products} onClick={clickProducts}>
      {!productId && <Product title="Items in Design" loading={itemLoading} data={items} name="product" savedProductIds={savedProductIds} allSavedProducts={props.allSavedProducts} />}
      {productId && <Product title="Similar Items" loading={itemLoading} data={similar} name="product" savedProductIds={savedProductIds} allSavedProducts={props.allSavedProducts} markedId={productId} />}
      {isAuthenticated && <SaveAllProductsBtn allIds={allIds} savedProductIds={savedProductIds} allSavedProducts={props.allSavedProducts} />}
    </div>
  )
}
